import skills from './Skills';
import SkillsModule from './SkillsModule';

export default {
  skills,
  SkillsModule,
};
